import { FormControl } from '@angular/forms';

export interface ISettingsItems {
  key: SUB_SETTINGS;
  title: string;
  icon: string;
  is_svg?: boolean;
  action: (item: ISettingsItems) => void;
}

export interface ISubSetting {
  key: SUB_SETTINGS;
  title: string;
}

export interface SettingsForm {
  keyboard: FormControl,
  is_message_read: FormControl,
  is_lazy_loading: FormControl,
  is_chat_unpin: FormControl,
}

export enum SUB_SETTINGS {
  GENERAL_SETTINGS = 'GENERAL_SETTINGS',
  BLOCKED_USERS = 'BLOCKED_USERS',
  FAST_REPLY = 'FAST_REPLY',
  CHAT_TAGS = 'CHAT_TAGS',
}

export enum SETTINGS_KEYS {
  HOT_KEY_SEND_CHAT = 'hot_key_send_chat',
  IS_MESSAGE_READ = 'is_message_read',
  IS_LAZY_LOADING = 'is_lazy_loading',
  IS_CHAT_UNPIN = 'is_chat_unpin',
}

export enum KEYBOARD {
  ENTER = 'enter',
  CMD_ENTER = 'cmd_enter',
  SHIFT_ENTER = 'shift_enter',
}

export interface IBlockedUser {
  id: string;
  name: string;
  user_id: string;
  type: string;
}
